import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, HashRouter, Route, Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './components/Login/AuthProvider';
import { ChatAuthProvider } from './components/AIchatbot/Auth/ChatAuthProvider';
import UserChatApp from './components/AIchatbot/chat/UserChatApp';
import { TechPredAuthProvider } from './components/TechPred/Auth/TechPredAuthProvider';
import Landing from './landing/Landing';
import Guntechchat from './guntechchatbot/Guntechchat';
import { JobDescriptionAuthProvider } from './guntechjobdesc/Job_Description/Auth/JobDescAuthProvider';
import { PrescriptionDetectorAuthProvider } from './prescriptionDetector/Auth/PrescriptionDetectorAuthProvider';
import { RecommendationEngineAuthProvider } from './recommendation/Auth/RecommendationEngineAuthProvider';
import { RealEstateAuthProvider } from './real-e-state/pages/Auth/RealEstateAuthProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div>
    <RealEstateAuthProvider>
    <RecommendationEngineAuthProvider>
    <PrescriptionDetectorAuthProvider>
    <JobDescriptionAuthProvider>
      <TechPredAuthProvider>
        <AuthProvider>
          <ChatAuthProvider>
            <HashRouter>
              <App />

              {/* <ToastContainer
      position="top-center"
      autoClose={3000}
      draggable
      pauseOnHover
      theme="colored"
    /> */}
              <Routes>
                <Route path="aichatbotapp/chatwindow/chat/:token" element={<UserChatApp />} />
              </Routes>
            </HashRouter>
          </ChatAuthProvider>
        </AuthProvider>
      </TechPredAuthProvider>
    </JobDescriptionAuthProvider>
    </PrescriptionDetectorAuthProvider>
    </RecommendationEngineAuthProvider>
    </RealEstateAuthProvider>
  </div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
